export default __webpack_public_path__ + "static/media/r4.e8a05ecc.png";